import axios from 'axios';
import apiClient from './api/apiClient';

class LoggerService {
    private async sendLog(level: string, message: string) {
        const logEntry = {
            Level: level,
            Message: message,
            Timestamp: new Date().toISOString(),
        };

        try {
            await apiClient.post('/api/log', logEntry);
        } catch (error) {
            console.error("Erreur d'envoi du log:", error);

            if (axios.isAxiosError(error)) {
                console.error('Erreur Axios:', {
                    config: error.config,
                    response: error.response,
                    request: error.request,
                });
            }
        }
    }

    info(message: string) {
        console.info(message);

        try {
            this.sendLog('Information', message);
        } catch {}
    }

    warn(message: string) {
        console.warn(message);

        try {
            this.sendLog('Warning', message);
        } catch {}
    }

    error(message: string) {
        console.error(message);

        try {
            this.sendLog('Error', message);
        } catch {}
    }
}

export const logger = new LoggerService();
